<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="ded">
<p class="dedf">For my parents, William Diderichsen Webber</p>
<p class="ded">and Marilynn Carlson Webber,</p>
<p class="ded">who taught me that books can make real</p>
<p class="ded">a time and place gone by.</p>
<p class="dedf">For those of Hawaiian heritage</p>
<p class="ded">who proudly preserve their culture.</p>
<p class="dedf">For all who love Ka‘iulani’s beautiful islands</p>
<p class="ded">and seek to live in the true spirit of aloha.</p>
<p class="dedf">And for my princess, Linnéa Juliet Scott.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-kaiulani-0006.vue?2b0b0fa0